<div layoutDir="row" class="container">
    <div >{{currentRow}}-{{ min( (currentRow + this.pageSize - 1), total)}} of {{total | formattedNumber}}</div>
    <button [disabled]="this.currentRow==1" mat-icon-button (click)="addToCurrent(-1)"><mat-icon>chevron_left</mat-icon></button>
    <button [disabled]="this.total < (this.currentRow + this.pageSize) " mat-icon-button (click)="addToCurrent(1)"><mat-icon>chevron_right</mat-icon></button>
</div>
